export interface RotoMachineArmData {
    note: string;
}


export interface RotoMachine {
    id: string;
    name: string;
    arms: RotoMachineArm[];
    factoryNodeId: string;
    labelPrinterId: string;
    approximateDailyCycleCount: number;
}

export interface RotoMachineArm {
    id: string;
    note: string;
    type: RotoMachineArmType
}

export enum RotoMachineArmType {
    Standard = 'Standard',
    Offset = 'Offset',
}